import { render, staticRenderFns } from "./RateCallRequest.vue?vue&type=template&id=5ae2c82b"
import script from "./RateCallRequest.vue?vue&type=script&lang=js"
export * from "./RateCallRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports